"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonVisitedPlacesConfirmNextSection = exports.buttonDeleteVisitedPlace = exports.buttonCancelVisitedPlace = exports.buttonSaveVisitedPlace = exports.visitedPlaceDepartureTime = exports.visitedPlaceNextPlaceCategory = exports.visitedPlaceArrivalTime = exports.visitedPlacePreviousDepartureTime = exports.visitedPlacePreviousArrivalTime = exports.visitedPlacePreviousPreviousDepartureTime = exports.visitedPlaceGeography = exports.visitedPlaceName = exports.visitedPlaceShortcut = exports.visitedPlaceAlreadyVisited = exports.visitedPlaceOnTheRoadArrivalType = exports.visitedPlaceOnTheRoadDepartureType = exports.visitedPlaceActivity = exports.visitedPlaceActivityCategory = exports.personVisitedPlaces = exports.personVisitedPlacesMap = exports.personVisitedPlacesTitle = exports.buttonSwitchPerson = exports.activePersonTitle = void 0;
const escape_1 = __importDefault(require("lodash/escape"));
const defaultInputBase = __importStar(require("evolution-frontend/lib/components/inputs/defaultInputBase"));
const validations = __importStar(require("evolution-common/lib/services/widgets/validations/validations"));
const odSurveyHelpers = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const choices = __importStar(require("../../common/choices"));
const customConditionals = __importStar(require("../../common/customConditionals"));
const customWidgets = __importStar(require("./customWidgets"));
const customChoices = __importStar(require("./customChoices"));
exports.activePersonTitle = customWidgets.activePersonTitle;
exports.buttonSwitchPerson = customWidgets.buttonSwitchPerson;
exports.personVisitedPlacesTitle = customWidgets.personVisitedPlacesTitle;
exports.personVisitedPlacesMap = customWidgets.personVisitedPlacesMap;
exports.personVisitedPlaces = customWidgets.personVisitedPlaces;
exports.visitedPlaceActivityCategory = customWidgets.visitedPlaceActivityCategory;
exports.visitedPlaceActivity = customWidgets.visitedPlaceActivity;
exports.visitedPlaceOnTheRoadDepartureType = customWidgets.visitedPlaceOnTheRoadDepartureType;
exports.visitedPlaceOnTheRoadArrivalType = Object.assign(Object.assign({}, defaultInputBase.inputRadioBase), { path: 'onTheRoadArrivalType', twoColumns: false, containsHtml: false, label: (t, interview, path) => {
        const activePerson = odSurveyHelpers.getPerson({ interview, path });
        const nickname = (0, escape_1.default)((activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname'));
        const countPersons = odSurveyHelpers.countPersons({ interview });
        return t('visitedPlaces:onTheRoadArrivalType', {
            nickname,
            context: (activePerson === null || activePerson === void 0 ? void 0 : activePerson.gender) || (activePerson === null || activePerson === void 0 ? void 0 : activePerson.sexAssignedAtBirth),
            count: countPersons
        });
    }, choices: customChoices.onTheRoadArrivalTypeCustomChoices, conditional: customConditionals.currentPlaceWorkOnTheRoadAndNoNextPlaceCustomConditional, validations: validations.requiredValidation });
exports.visitedPlaceAlreadyVisited = Object.assign(Object.assign({}, defaultInputBase.inputRadioBase), { path: 'alreadyVisitedBySelfOrAnotherHouseholdMember', twoColumns: false, containsHtml: true, label: (t, interview, path) => {
        const activePerson = odSurveyHelpers.getPerson({ interview, path });
        const nickname = (0, escape_1.default)((activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname'));
        const countPersons = odSurveyHelpers.countPersons({ interview });
        return t('visitedPlaces:alreadyVisitedBySelfOrAnotherHouseholdMember', {
            nickname,
            count: countPersons
        });
    }, choices: choices.yesNo, conditional: customConditionals.alreadyVisitedPlaceCustomConditional, validations: validations.requiredValidation });
exports.visitedPlaceShortcut = customWidgets.visitedPlaceShortcut;
exports.visitedPlaceName = customWidgets.visitedPlaceName;
exports.visitedPlaceGeography = customWidgets.visitedPlaceGeography;
exports.visitedPlacePreviousPreviousDepartureTime = customWidgets.visitedPlacePreviousPreviousDepartureTime;
exports.visitedPlacePreviousArrivalTime = customWidgets.visitedPlacePreviousArrivalTime;
exports.visitedPlacePreviousDepartureTime = customWidgets.visitedPlacePreviousDepartureTime;
exports.visitedPlaceArrivalTime = customWidgets.visitedPlaceArrivalTime;
exports.visitedPlaceNextPlaceCategory = customWidgets.visitedPlaceNextPlaceCategory;
exports.visitedPlaceDepartureTime = customWidgets.visitedPlaceDepartureTime;
exports.buttonSaveVisitedPlace = customWidgets.buttonSaveVisitedPlace;
exports.buttonCancelVisitedPlace = customWidgets.buttonCancelVisitedPlace;
exports.buttonDeleteVisitedPlace = customWidgets.buttonDeleteVisitedPlace;
exports.buttonVisitedPlacesConfirmNextSection = customWidgets.buttonVisitedPlacesConfirmNextSection;
